import * as React from 'react';
export type ScreenDevice = 'mobile' | 'tablet' | 'desktop';

export enum DeviceBreakpoints {
    mobile = 768,
    tablet = 1280,
    desktop = 1281,
}

export const calcScreenDevice = (width: number): ScreenDevice => {
    if (width <= DeviceBreakpoints.mobile) {
        return 'mobile';
    } else if (width > DeviceBreakpoints.mobile && width <= DeviceBreakpoints.tablet) {
        return 'tablet';
    } else if (width >= DeviceBreakpoints.desktop) {
        return 'desktop';
    }
};

export const useResponsiveDevice = (): ScreenDevice => {
    const [device, setDevice] = React.useState<ScreenDevice>(() => calcScreenDevice(window.innerWidth));

    React.useEffect(() => {
        function onResize() {
            setDevice(calcScreenDevice(window.innerWidth));
        }

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return device;
};
